import React from 'react';

const STEPS = [
  { tag: 'Step 1', title: 'Choose your width', text: 'Go bold with 1.5" for statement panels, or fine with 5/8" for trims and detail work.', chip: '1.5" or 5/8"' },
  { tag: 'Step 2', title: 'Pick your colors', text: 'Choose from 26 colors in each size, from bright reds and blues to earthy browns and black-pattern styles.', chip: '26 colors' },
  { tag: 'Step 3', title: 'Create something meaningful', text: 'Sew it into a ribbon skirt, a shirt, regalia or a gift, and carry the pattern forward.', chip: 'Your story' },
];

export const RibbonSteps = () => (
  <section className="relative py-20 sm:py-28 overflow-hidden" data-testid="ribbon-steps">
    <div className="absolute right-0 top-1/3 w-[500px] h-[500px] rounded-full bg-[#ff4d00]/20 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <p className="rb-eyebrow mb-4">How it works</p>
      <h2 className="rb-head text-5xl sm:text-6xl lg:text-7xl mb-14 max-w-3xl">
        <span className="rb-neon">Made for</span> <span className="rb-grad">Makers.</span>
      </h2>
      <ol className="grid md:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <li key={s.tag} className="relative rb-glass rb-glass-hover rounded-3xl p-8 overflow-hidden" data-testid={`step-${i + 1}`}>
            <span className="rb-head text-8xl absolute -top-2 right-4 rb-grad opacity-80">{i + 1}</span>
            <p className="rb-eyebrow mb-4">{s.tag}</p>
            <h3 className="rb-head text-3xl text-white mb-3 pr-14">{s.title}</h3>
            <p className="text-white/65 leading-relaxed mb-6">{s.text}</p>
            <span className="inline-block rounded-full rb-btn px-4 py-1.5 text-sm font-bold uppercase tracking-wider">{s.chip}</span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
